<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full mt-3">
          <ul class="heading-ul mb-3">
            <li>
              <div class="vx-row">
                <feather-icon
                  class="back-btn"
                  @click="$router.go(-1)"
                  icon="ArrowLeftIcon"
                  svgClasses="text-dark"
                />
                <h3>{{ $t("accounting.label.createglaccount") }}</h3>
              </div>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.accounttype")
                }}</small>
                <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.accounttype')"
              >
                <v-select
                  label="value"
                  v-model="accountType"
                  :options="TemplateData.accountTypeOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.value }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.parent")
                }}</small>
                <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.parent')"
              >
                <v-select
                  label="name"
                  v-model="parent"
                  :options="parentOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.glcode')"
              >
                <vs-input
                  :label="$t('accounting.label.glcode')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="glCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.accountname')"
              >
                <vs-input
                  :label="$t('accounting.label.accountname')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="accountName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.accountusage")
                }}</small>
                <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.accountusage')"
              >
                <v-select
                  label="value"
                  v-model="accountUsage"
                  :options="TemplateData.usageOptions"
                  :reduce="(obj) => obj.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  class="w-full mb-2"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.tag")
                }}</small>
                <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.tag')"
              >
                <v-select
                  label="name"
                  v-model="tag"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :options="tagOptions"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.description')"
              >
              <vs-input
                :label="$t('accounting.label.description')"
                class="w-full mb-2 font-semibold"
                v-model="description"
              />
              <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox
                class="mt-5 mb-5 font-semibold"
                v-model="manualEntriesAllowed"
                >{{ $t("accounting.label.manualentriesallowed") }}</vs-checkbox
              >
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="haldleSubmit"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      accountType: "",
      parent: "",
      glCode: "",
      accountName: "",
      accountUsage: "",
      tag: "",
      description: "",
      manualEntriesAllowed: "true",
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      TemplateData: (state) => state.accounting.accountTemplate,
    }),
    parentOptions() {
      switch (this.accountType) {
        case 1:
          return this.TemplateData.assetHeaderAccountOptions;
        case 2:
          return this.TemplateData.liabilityHeaderAccountOptions;
        case 3:
          return this.TemplateData.equityHeaderAccountOptions;
        case 4:
          return this.TemplateData.incomeHeaderAccountOptions;
        case 5:
          return this.TemplateData.expenseHeaderAccountOptions;
        default:
          return [];
      }
    },
    tagOptions() {
      switch (this.accountType) {
        case 1:
          return this.TemplateData.allowedAssetsTagOptions;
        case 2:
          return this.TemplateData.allowedLiabilitiesTagOptions;
        case 3:
          return this.TemplateData.allowedEquityTagOptions;
        case 4:
          return this.TemplateData.allowedIncomeTagOptions;
        case 5:
          return this.TemplateData.allowedExpensesTagOptions;
        default:
          return [];
      }
    },
  },
  methods: {
    async getTemplateData() {
      try {
        await this.$store.dispatch("accounting/accountTemplateDataAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetForm() {
      this.accountType = "";
      this.parent = "";
      this.glCode = "";
      this.accountName = "";
      this.accountUsage = "";
      this.tag = "";
      this.description = "";
      this.manualEntriesAllowed = "true";
      this.warningPopup = false;
      this.warningText = "";
      this.errorMessage = "";
    },
    async haldleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        description: this.description,
        glCode: this.glCode,
        manualEntriesAllowed: this.manualEntriesAllowed,
        name: this.accountName,
        parentId: this.parent,
        tagId: this.tag,
        type: this.accountType,
        usage: this.accountUsage,
      };
      try {
        await this.$store.dispatch("accounting/createGLAccountAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "GL Account Created Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push("/chart_of_accounts");
      } catch (error) {
        const errorMessage = String(error.httpStatusCode).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
        // if (e.httpStatusCode) {
        //   this.errorMessage = e.errors[0].defaultUserMessage;
        // }
        // console.log("something went to wrong while creating entity:", e);
      }
    },
  },
  watch: {
    accountType(newValue) {
      if (newValue && !this.$route.query.subledger) {
        this.parent = "";
        this.tag = "";
      } else {
        this.tag = "";
      }
    },
  },
  mounted() {
    this.getTemplateData();
    const query = this.$route.query;
    if (query.subledger) {
      this.accountType = query.accType;
      this.parent = query.parent;
    }
  },
};
</script>
<style>
.back-btn {
  cursor: pointer;
}
</style>
